import * as TYPE from './mutation-types';

export default {
  [TYPE.ADD_OVERLAY](state, overlayName) {
    const index = state.allShowedOverlays.indexOf(overlayName);

    if (!state.allShowedOverlays.includes(overlayName)) {
      state.allShowedOverlays.push(overlayName);
      document.body.style.overflow = 'hidden';
    } else {
      state.allShowedOverlays.splice(index, 1);
      document.body.style.overflow = 'auto';
      state.popupData = null;
      state.titlePopup = null;
      state.buttonPopup = null;
    }
  },
  [TYPE.POPUP_DATA](state, params) {
    state.popupData = params;
  },
  [TYPE.CLOSE_ALL_POPUPS](state) {
    state.allShowedOverlays = [];
  },
  [TYPE.TITLE_POPUP](state, title) {
    state.titlePopup = title;
  },
  [TYPE.BUTTON_POPUP](state, title) {
    state.buttonPopup = title;
  },
  [TYPE.CONTENT_REVIEW](state, content) {
    state.contentReview = content;
  },
};
